import { Helmet } from "react-helmet";
import Navbar from "../../../../components/Navbar/Navbar";
import WhatsAppWidget from "../../../../components/Navbar/Whatsapp";
import Banner from "../../../../components/body/projectPageComponents/Banner";
import Overview from "../../../../components/body/projectPageComponents/Overview";
import Pricing from "../../../../components/body/projectPageComponents/Pricing";
import Gallery from "../../../../components/body/projectPageComponents/Gallery";
import Location from "../../../../components/body/projectPageComponents/Location";
import Highlights from "../../../../components/body/projectPageComponents/Highlights";
import SiteVisitBanner from "../../../../components/body/projectPageComponents/SiteVisitBanner";
import FloorPlans from "../../../../components/body/projectPageComponents/FloorPlans";
import Amenities from "../../../../components/body/projectPageComponents/Amenities";
import Faq from "../../../../components/body/projectPageComponents/Faq";
import SimilarProject from "../../../../components/body/projectPageComponents/SimilarProject";

import { projectsmantri } from "../../../../data/projects/mantri/data";
import { projectspurvankara } from "../../../../data/projects/puravankara/data";

export const PurvankaraParkHill = () => {
  const {
    parkhill: {
      form_data,
      whatsapp,
      bannerdata,
      overview,
      sitevisit,
      pricing,
      floor_plan,
      highlights,
      location,
      gallery,
      faq,
      similar
    }
  } = projectspurvankara;

  return (
    <>
      <Helmet>
        <title>Purva Park Hill Mallasandra, Bengaluru – Luxury Apartments by Puravankara</title>

        <meta
          name="description"
          content="Discover Purva Park Hill in Mallasandra, Bengaluru – a premium residential project by Puravankara. Experience luxury living with world-class amenities, spacious apartments, and lush green surroundings. Book your dream home today!"
        />

        <meta
          name="keywords"
          content="Purva Park Hill, Puravankara Purva Park Hill, Purva Park Hill Mallasandra, Purva Park Hill Bengaluru, Purva Park Hill price, Purva Park Hill apartments, luxury apartments Bengaluru, Mallasandra real estate"
        />

        <link
          rel="canonical"
          href="https://propertystation.in/puravankara-purva-park-hill-mallasandra-bengaluru"
        />

        <meta
          name="robots"
          content="index, follow"
        />

      </Helmet>

      <WhatsAppWidget whatsappdata={whatsapp} />
      <Navbar />

      <div className="mt-20">
        <Banner
          bannerDesktopImage={bannerdata.bannerDesktopImage}
          bannerMobileImage={bannerdata.bannerMobileImage}
          data={bannerdata.data}
          formData={form_data}
        />
        <Overview overviewData={overview} stripdata={overview.stripdata} />
        <SiteVisitBanner image={sitevisit.image} formData={form_data} />
        <Pricing pricingData={pricing} formData={form_data} />
        <FloorPlans floorPlans={floor_plan} formData={form_data} />
        <Highlights hightlightData={highlights} formData={form_data} />
        <Amenities />
        <Location location={location} />
        <Gallery galleryData={gallery} />
        <Faq faqdata={faq} />
        <SimilarProject Similarprojects={similar} />
      </div>
    </>
  );
};
